/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Switch,
} from '@material-ui/core';
import {
  Add as AddIcon,
  Description,
  FindInPage,
  MoreHoriz,
  Restore,
  Update,
} from '@material-ui/icons';
import RoomIcon from '@material-ui/icons/Room';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  deleteSubscribeJob,
  getCountSouscriptionOffers,
  getJobsSubscribe,
  setStatusSouscriptionOffer,
} from '@webapps/business';
import {
  Loader,
  Modal,
  ModalSideBar,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import theme from '../theme';
import AddBusinessSubscribe from './AddBusinessSubscribe';
import Preferences from './Preferences';
import ViewBusinessSubscribe from './ViewBusinessSubscribe';

const {
  colors: { addressColor },
} = theme;

const Entreprise = ({ handleEmploiLength }) => {
  const {
    css,
    classes,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [addBusinessSubscribe, setAddBusinessSubscribe] = useState(false);
  const { idUser } = useAuth();

  const handleOpenAddBusinessSubscribe = () => {
    setAddBusinessSubscribe(true);
  };
  const handleCloseAddBusinessSubscribe = () => {
    setAddBusinessSubscribe(false);
  };

  const {
    data: subscribes = [],
    isLoading,
    refetch,
  } = useQuery(getJobsSubscribe, {
    key: 'jobsSubscribe',
    variables: {
      id: idUser,
    },
  });

  useEffect(() => {
    handleEmploiLength(subscribes?.length);
  }, [subscribes?.length]);

  return (
    <div>
      <div
        className={css({
          display: subscribes?.length > 0 ? 'flex' : 'none',
          justifyContent: 'flex-start',
        })}
      >
        <Button
          onClick={handleOpenAddBusinessSubscribe}
          color="primary"
          variant="contained"
          className={classes.addSubBouton}
        >
          Ajouter une souscription
        </Button>
      </div>
      {isLoading && <Loader />}
      <Grid
        container
        style={
          subscribes.length === 0
            ? {
              display: 'flex',
              justifyContent: 'center',
              padding: spacing(2.5),
              backgroundColor: '#F3F7FF',
              borderRadius: 10,
            }
            : {
              display: 'flex',
              backgroundColor: '#F3F7FF',
              borderRadius: 10,
              padding: spacing(2.5, 0, 0, 2.5),
              height: '100%'
            }
        }
      >
        {!subscribes?.length && !isLoading ? (
          <Grid
            container
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid
              item
              className={css({
                backgroundColor: '#FFFFFF',
                borderRadius: 12,
                padding: '30.0px',
                '@media screen and (max-width: 768px)': {
                  padding: '20px',
                },
              })}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <h1
                  className={cx(css({
                    textAlign: 'center',
                    margin: '0px 0px 30px 0px',
                  }), global.title)}
                >
                  {' '}
                  Ayez toujours un coup d'avance avec les souscriptions !
                </h1>
                <p style={{ textAlign: 'center', margin: '5px' }}>
                  {' '}
                  1. Configurez votre souscription selon vos critères
                </p>
                <p style={{ textAlign: 'center', margin: '5px' }}>
                  {' '}
                  2. Soyez informé des nouvelles offres d'emploi par email.
                </p>
                <p
                  style={{ textAlign: 'center', margin: '5px 5px 30px 5px' }}
                >
                  {' '}
                  3. Supprimez les dès que bon vous semble, et ça sans limite !
                </p>
                <Button
                  className={classes.btn}
                  color="primary"
                  variant="contained"
                  onClick={handleOpenAddBusinessSubscribe}
                  disableElevation={true}
                >
                  Ajouter une souscription
                </Button>
              </div>
            </Grid>
          </Grid>
        ) : (
          <Grid
            container
            style={{ backgroundColor: '#F3F7FF', borderRadius: 10 }}
          >
            {subscribes?.map(
              ({
                active,
                alertFrequency,
                businesses,
                city,
                contractTypes,
                id,
                label,
                levels,
                sectors,
              }) => (
                <Grid item md={6} lg={3} xs={12}>
                  <div style={{ padding: spacing(0, 2.5, 2.5, 0) }}>
                    <Item
                      key={id}
                      active={active}
                      alertFrequency={alertFrequency}
                      businesses={businesses}
                      city={city}
                      contractTypes={contractTypes}
                      id={id}
                      label={label}
                      levels={levels}
                      refetch={refetch}
                      sectors={sectors}
                    />
                  </div>
                </Grid>
              )
            )}
          </Grid>
        )}
      </Grid>
      {/*<div className={css({ marginTop: spacing(2.5), marginBottom: spacing(2.5) })}>
        <Divider />
      </div>
      <Preferences />
              */}
      <Modal
        onCancel={handleCloseAddBusinessSubscribe}
        open={addBusinessSubscribe}
        title={<FormattedMessage id="addBusinessSubscribe.title" />}
      >
        <AddBusinessSubscribe
          close={handleCloseAddBusinessSubscribe}
          refetch={refetch}
        />
      </Modal>
    </div>
  );
};

const Item = ({
  active,
  alertFrequency,
  businesses,
  city,
  contractTypes,
  id,
  label,
  levels,
  refetch,
  sectors,
}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { push } = useRouter();

  const [viewSubscribe, setViewSubscribe] = useState(false);
  const [idSubscribe, setIdSubscribe] = useState(null);

  const { data: countSouscription = '' } = useQuery(
    getCountSouscriptionOffers,
    {
      key: 'countSouscription',
      variables: { id },
    }
  );

  const handleOpenViewSubscribe = () => {
    setViewSubscribe(true);
  };
  const handleCloseViewSubscribe = () => {
    setIdSubscribe(null);
    setViewSubscribe(false);
  };

  const {
    isLoading: isLoadingSouscription,
    isSuccess,
    mutateAsync: mutateSetStatus,
  } = useMutation(setStatusSouscriptionOffer);

  const handleSetStatus = async (e, idSouscription) => {
    await mutateSetStatus({
      id: idSouscription,
      status: e.target.checked,
    });
  };

  const getFrequenceLabel = (value) => {
    if (value === 'daily') {
      return 'Quotidienne';
    }
    if (value === 'weekly') {
      return 'Hebdomadaire';
    }
    return 'Mensuelle';
  };

  const openViewSubscribe = (idSous) => {
    setIdSubscribe(idSous);
    handleOpenViewSubscribe();
  };

  useEffect(() => {
    if (isSuccess) {
      refetch();
    }
  }, [isSuccess]);

  const goToCart = () => {
    push(ROUTES_PATH.MYMAP, {
      searchParams: {
        cities: city,
        businesses: businesses?.map(({ id: idBusiness }) => idBusiness).join(),
        contracts: contractTypes
          ?.map(({ id: idContract }) => idContract)
          .join(),
        sectors: sectors?.map(({ id: idSector }) => idSector).join(),
        degrees: levels?.map(({ id: idLevel }) => idLevel).join(),
      },
      from: 'souscriptionBusiness',
    });
  };

  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDeleteSubscribe,
  } = useMutation(deleteSubscribeJob);

  const { addToast } = useToast();

  const deleteSubscribe = async () => {
    await mutateDeleteSubscribe({
      id,
    });
  };

  useEffect(() => {
    if (isSuccessDelete) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      close();
    }
  }, [isSuccessDelete]);

  const [anchorSub, setAnchorSub] = useState(null);

  const openCandid = Boolean(anchorSub);

  const handleClick = (event) => {
    setAnchorSub(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorSub(null);
  };

  return (
    <>
      <div
        style={{
          borderRadius: 10,
          backgroundColor: 'white',
          padding: spacing(2.5),
        }}
      >
        <Grid>
          <Grid>
            <div>
              <div className={classes.header}>
                <div className={global.title}>{label.slice(0, 30)}</div>
                <IconButton
                  onClick={handleClick}
                  size="small"
                  aria-controls={openCandid ? 'sub-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={openCandid ? 'true' : undefined}
                  style={{
                    margin: '0px 3px',
                    alignSelf: 'baseline',
                    borderRadius: '20px',
                    border: '1px solid #C0D9FF',
                    backgroundColor: '#F3F7FF',
                    width: '26px',
                    display: 'flex',
                    justifyContent: 'center',
                    height: '26px',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <MoreHoriz style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
                </IconButton>
              </div>
              <div className={cx(global.infoText, classes.address)}>
                <Description className={cx(global.infoIcon, classes.imgAdress)} />
                {contractTypes.map((items, i) => (
                  <>
                    {items.label}
                    {i === contractTypes.length - 1 ? '' : ', '}
                  </>
                ))}
              </div>
              <div className={cx(global.infoText, classes.address)}>
                <RoomIcon className={cx(global.infoIcon, classes.imgAdress)} />
                {city}
              </div>
              <div className={cx(global.infoText, classes.address)}>
                <Restore className={cx(global.infoIcon, classes.imgAdress)} />
                {getFrequenceLabel(alertFrequency)}
              </div>
              <div
                className={cx(global.infoText, classes.address)}
                style={{ cursor: 'pointer', color: '#0060F9' }}
                onClick={goToCart}
              >
                <FindInPage className={cx(global.infoIcon, classes.imgAdress)} />
                {countSouscription.length !== 0 ? (
                  'Aucune offre disponible'
                ) : (
                  <>
                    {countSouscription}{' '}
                    <FormattedMessage id="student.souscription.offreDispo" />
                  </>
                )}
              </div>
            </div>
          </Grid>
          <Menu
            anchorEl={anchorSub}
            id="sub-menu"
            open={openCandid}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{ elevation: 2 }}
            transformOrigin={{ horizontal: 'left', vertical: -50 }}
            anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
          >
            <MenuItem
              disableRipple
              disableFocusRipple
              onClick={() => openViewSubscribe(id)}
            >
              Détails
            </MenuItem>
            <MenuItem
              disableRipple
              disableFocusRipple
              onClick={() => deleteSubscribe(id)}
            >
              Supprimer
            </MenuItem>

            {/* {isLoadingStatusSouscription ?
              <MenuItem
                disableRipple disableFocusRipple onClick={() => handleSetStatus(id)}>
                Activer
              </MenuItem> :
              <MenuItem
                disableRipple disableFocusRipple onClick={() => handleSetStatus(id)}>
                Désactiver
              </MenuItem>} */}
          </Menu>
        </Grid>
        <Box
          className={classes.boxSwitch}
          style={
            active
              ? { backgroundColor: '#DBFAD8', color: '#8FE685' }
              : { backgroundColor: '#F3F7FF', color: '#5D75A8' }
          }
        >
          <FormControlLabel
            control={
              <Switch
                checked={active}
                classes={{
                  switchBase: css({
                    color: '#ccc',
                    '&.Mui-checked': css({
                      color: '#8FE685',
                    }),
                    '&.Mui-checked + .MuiSwitch-track': css({
                      backgroundColor: '#8FE685',
                    }),
                  }),
                  checked: css({}),
                  track: css({}),
                }}
                color="#5D75A8"
                disabled={isLoadingSouscription}
                onChange={(e) => handleSetStatus(e, id)}
                size="small"
              />
            }
          />
          <span style={{ color: active ? '#008000' : '#5A6DA1' }}>
            {active ? 'Souscription activée' : 'Souscription désactivée'}
          </span>
        </Box>
      </div>
      <ModalSideBar
        handleClose={handleCloseViewSubscribe}
        open={viewSubscribe}
        title={<FormattedMessage id="viewSubscrive.title" />}
      >
        <ViewBusinessSubscribe
          close={handleCloseViewSubscribe}
          id={idSubscribe}
          refetch={refetch}
        />
      </ModalSideBar>
    </>
  );
};

Item.propTypes = {
  active: PropTypes.bool,
  alertFrequency: PropTypes.string,
  city: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  refetch: PropTypes.func,
  businesses: PropTypes.object,
  sectors: PropTypes.object,
  contractTypes: PropTypes.object,
  levels: PropTypes.object,
};

const styles = ({ spacing }) => ({
  avatar: {
    height: 60,
    width: 60,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  address: {
    marginTop: spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  imgAdress: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: spacing(1),
  },
  addSubBouton: {
    marginBottom: spacing(2.5),
    '@media only screen and (max-width:768px)': { width: '100%' },
  },
  boxSwitch: {
    padding: spacing(1),
    display: 'flex',
    justifyContent: 'center',
    borderRadius: 25,
    width: '70%',
    marginTop: spacing(2),
    alignItems: 'center',
    '@media only screen and (max-width:767px)': { width: '100%' },
    '@media only screen and (max-width:768px)': { width: '100%' },
    '@media only screen and (min-width:1280px)': { width: '85%' },
    '@media only screen and (min-width:1670px)': { width: '55%' },
  },
});

export default Entreprise;
